import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kve-edit-grid',
  templateUrl: './edit-grid.component.html',
  styleUrls: ['./edit-grid.component.scss']
})
export class EditGridComponent implements OnInit {
  title:string = "Edit Existing Grid";
  toolTip:string = "Color range used for general elements such as backgrounds, buttons and text.You can override this for specific elements.";
  constructor() { }

  ngOnInit(): void {
  }

}
